import { ShareType } from 'src/local-logic/utils/share-panel';
import { getUrlPara } from '@tencent/pmd-tools/lib/url';
import { post } from '@tencent/pmd-network';
import { isTestEnv } from '@tencent/pmd-tools/lib/env';
import { redirectToWebContainerInPC } from '@tencent/press-plus/common/web-container/index';


export const KEY_SCENE = 'scene';

export const DOUYU_CHANNEL_NAME = 'key_douyu_channel_name';
export const DOUYU_CHANNEL_LOGO = 'key_douyu_channel_logo';
export const DOUYU_CHANNEL_ID = 'key_douyu_channel_id';
export const DOUYU_PARAM = 'key_douyu_param';
export const EXT_PLAT = 'key_ext_plat';
export const DOUYU_DEFAULT_LOGO = 'https://igame-10037599.cos.ap-shanghai.myqcloud.com/4ae278d2-d079-2bfd-9516-c51c536b9ccb';
function isDouyuScene(to) {
  const isDouyu =  to.query && to.query[KEY_SCENE] && to.query[KEY_SCENE] === 'douyu';
  return isDouyu;
}
function isDouyuOrigin(to) {
  if (!isDouyuScene(to)) {
    return false;
  }
  // 创建比赛
  if (to.name === 'create') {
    return true;
  }
  // 管理比赛
  if (to.name === 'douyu-channel-match' && to.query.isAdmin === '1') {
    return true;
  }
  return false;
}

export function isInDouyuIframe() {
  // #ifdef H5
  try {
    const accessable = typeof window.parent?.location?.href === 'string';
    return !accessable;
  } catch (e) {
    return window.self !== window.parent; // 如果报错了 说明不在赛宝的iframe里 在其他域的iframe里
  }
  // #endif
}
// 确保每一个参数都有值 不然丢弃
export function cleanedUrlParams(query) {
  const params = (query || '').split('&').filter(item => item.split('=')?.length === 2)
    .join('&');
  return params;
}

const pathWhiteList = ['web-container', 'third-plat-login', 'ai-room', 'test-whitelist'];
const disableWebContainerList = ['ai-room'];
const corePath = '/pvpesport.next.user';


export function redirectToWebContainer(options) {
  return redirectToWebContainerInPC({
    pathWhiteList,
    disableWebContainerList,
    corePath,

    router: options?.router,
    log: true,
    tag: options?.tag,
  });
}

export function initDouyuChannelRouter(router) {
  // 判断是否为斗鱼频道
  router.beforeEach((to, from, next) => {
    if (isDouyuOrigin(to)) {
      sessionStorage.setItem(KEY_SCENE, 'douyu');
      saveDouyuChannelInfo(to.query);
    }
    if (isDouyuScene(to)) {
      localStorage.setItem(EXT_PLAT, 'douyu');
    }


    next();
  });

  router.afterEach(() => {
    redirectToWebContainer({ router, tag: 'afterEach' });
  });
}
function saveDouyuChannelInfo(query) {
  const { avatar, channelName, cid, dyParam } = query;
  sessionStorage.setItem(DOUYU_CHANNEL_NAME, channelName || '');
  sessionStorage.setItem(DOUYU_CHANNEL_LOGO, avatar || '');
  sessionStorage.setItem(DOUYU_CHANNEL_ID, cid || '');
  sessionStorage.setItem(DOUYU_PARAM, dyParam) || '';
}

export function isDouyuChannel() {
  return sessionStorage.getItem(KEY_SCENE) === 'douyu' && window.self !== window.parent;
}

export function douyuChannelName() {
  return sessionStorage.getItem(DOUYU_CHANNEL_NAME) || '';
}

export function douyuChannelLogo() {
  return sessionStorage.getItem(DOUYU_CHANNEL_LOGO) || '';
}

export function douyuChannelId() {
  return sessionStorage.getItem(DOUYU_CHANNEL_ID) || '';
}

export function douyuParam() {
  return sessionStorage.getItem(DOUYU_PARAM) || '';
}

export function isFromDouyu() {
  return localStorage.getItem(EXT_PLAT) === 'douyu';
}

export function isInDouyuAppEnv() {
  const UA = navigator.userAgent.toLowerCase();
  const  isDouyuApp = !!(UA.match(/Douyu_Android/i) || UA.match(/Douyu_IOS/i));
  return isDouyuApp && window.parent !== window.self; // 如果不在斗鱼app的iframe 不能认为是斗鱼环境
}

export function setExtPlatScene() {
  const scene = getUrlPara(KEY_SCENE);
  if (scene) {
    localStorage.setItem(EXT_PLAT, scene);
  }
}

export const DouyuShareType = {
  douyuPanel: '0',
  weixin: '1',
  weixinZone: '2',
  qqZone: '3',
  weibo: '4',
  qq: '5',
  yuba: '6', // 鱼吧
};
const DOUYU_SHARE_MAP = {
  [ShareType.weixin]: DouyuShareType.weixin,
  [ShareType.weixinZone]: DouyuShareType.weixinZone,
  [ShareType.qq]: DouyuShareType.qq,
  [ShareType.qqZone]: DouyuShareType.qqZone,
  [ShareType.weibo]: DouyuShareType.weibo,
  [ShareType.yuba]: DouyuShareType.yuba,
  [ShareType.douyuPanel]: DouyuShareType.douyuPanel,
};

export function douyuShare({ type, link, name = '', content = '', url = '' }) {
  window.parent.postMessage({
    type: 'share',
    data: {
      url, // 图标logo
      link, // 分享的链接
      name,
      content,
      // img,
      // 分享的平台  0==所有,1==微信，2==朋友圈，3==QQ空间，4==微博，5==QQ，6== 鱼吧，7== 截屏分享（暂不支持给赛宝使用）。
      platform: DOUYU_SHARE_MAP[type] || DouyuShareType.douyuPanel,
      // imgBase64: '', // base64位图片字符
    },
  }, '*');
}

export function getDouyuMpScheme(reqData = {}) {
  return post({
    url: '/pvpesport.cgi.DouYuChannels.DouYuChannels/GetWechatAppScheme',
    reqData,
  });
}

export const DouyuAuthUrl = {
  test: 'https://live.dz11.com/topic/template/dy-auth',
  // 预发环境: https://www.dz11.com/topic/template/dy-auth
  // 灰度环境: https://www.douyu.com/topic/template/dy-auth
  prod: 'https://www.douyu.com/topic/dy-auth',
};


export const openNewPage = (targetUrl) => {
  if (window.self === window.parent) {
    window.location.href = targetUrl;
  } else {
    window?.parent?.postMessage({
      type: 'openPage',
      data: {
        targetUrl,
      },
    });
  }
};

export const goToDouyuWebPage = () => {
  const douyuUrl = isTestEnv() ? DouyuAuthUrl.test : DouyuAuthUrl.prod;
  let [linkUrl] = window.location.href.split('?');
  linkUrl = encodeURIComponent(`${linkUrl}?from=douyu_web`);
  const targetUrl =  `${douyuUrl}?bizType=wzMatchBot&linkUrl=${linkUrl}`;
  openNewPage(targetUrl);
};

export const openDouyuAuthPage = (event) => {
  window.location.href = event?.data?.data?.targetUrl;
};
